export default __webpack_public_path__ + "static/media/success.9f40abb7.svg";